// internal
import { axios, def, handleError, handleResponse } from './internal';

function R2Delete(bucket, url, service, onSuccess) {
    axios
        .post('/api/r2_delete', {
            bucket,
            url,
            service,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    onSuccess?.();
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { R2Delete };
